import { ShowFlash } from 'ng2/shared/flash/store/flash.actions';

module.exports = [
  '$ngRedux',
  '$rootScope',
  'SessionService',
  'SecurityService',
  '$state',
  'PatientAppContextService',

  function SessionListener(
    $ngRedux,
    $rootScope,
    SessionService,
    SecurityService,
    $state,
    PatientAppContextService,
  ) {
    $rootScope.$on('$stateChangeStart', (event, toState, toParams) => {
      // If URL does not contain a groupId, show a 404 error page
      if (!toParams.groupId && !toState.allowNoGroupId) {
        if (toState.name !== 'not_found') {
          event.preventDefault();
          $state.go('not_found');
          return false;
        }
      }

      if (toParams.confirmNewEmailState) {
        event.preventDefault();
        $rootScope.$emit('application:out', { groupId: toParams.groupId });
        return false;
      }

      return true;
    });

    $rootScope.$on('$stateChangeSuccess', (event, toState, toParams) => {
      const authenticatedPatient = PatientAppContextService.context.authenticatedPatient;

      if (SessionService.isInitialized()) {
        const groupId = parseInt(toParams.groupId);

        // If a logged user try to access another clinic where he's not registered, log him out and redirect to login page
        if (!SessionService.fetch().groups.some(group => (group.id === groupId))) {
          $rootScope.$emit('application:out', { error: 'patient_not_created' });
          return;
        }
      } else if (!toState.insecure) {
        // Forbid unlogged user access to secure pages (ie. ~ all pages except login & registration)
        $rootScope.$emit('application:out');
        return;
      }

      if (authenticatedPatient && !(['patient_agreement', 'privacy_statement'].includes(toState.name))) {
        // Authenticated user is 'activated'
        if (authenticatedPatient.state !== 'confirmed' && toState.name !== 'activation') {
          $state.go('activation');
        }

        // A confirmed patient has requested an email change
        if (authenticatedPatient.unconfirmedEmail) {
          $ngRedux.dispatch(new ShowFlash({ name: 'update-email', additionalInfos: { newEmail: authenticatedPatient.unconfirmedEmail } }));
        }
      }
    });

    // Rethrow swallowed errors from router resolve
    $rootScope.$on('$stateChangeError', (event, toState, toParams, fromState, fromParams, error) => {
      $state.go('not_found');
      throw error;
    });
  },
];



// WEBPACK FOOTER //
// ./main/config/listeners/session.js